import Icon404 from '../assets/Images/png/404-2.png';
import Group from '../assets/Images/png/Group.png';

const NotFoundPage = () => {
    return (
        <div className="w-full flex flex-1 mt-30">
            {/* component */}
            <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16">
                <div className="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
                    <div className="relative">
                        <div className="absolute">
                            <div className>
                                <h1 className="my-2 text-gray-800 font-bold text-2xl">
                                    Looks like you've found the doorway to the
                                    great nothing
                                </h1>
                                <p className="my-2 text-gray-800">
                                    Sorry about that! Please visit our homepage
                                    to get where you need to go.
                                </p>
                            </div>
                        </div>
                        <div>
                            <img src={Icon404} alt="icon" />
                        </div>
                    </div>
                </div>
                <div>
                    <img src={Group} alt="icon" />
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
